import { FormItem } from 'sections/EditForm';

const zoneTypes = [
  {
    value: JSON.stringify({
      key: 'D',
      value: 'Directional',
    }),
    label: 'Directional',
  },
  {
    value: JSON.stringify({
      key: 'F',
      value: 'Supplier',
    }),
    label: 'Supplier',
  },
  {
    value: JSON.stringify({
      key: 'V',
      value: 'Various',
    }),
    label: 'Various',
  },
  {
    value: JSON.stringify({
      key: 'P',
      value: 'Promotional',
    }),
    label: 'Promotional',
  },
  {
    value: JSON.stringify({
      key: 'A',
      value: 'Agent',
    }),
    label: 'Agent',
  },
  {
    value: JSON.stringify({
      key: '',
      value: 'Generic',
    }),
    label: 'Generic',
  },
]

export const zonesFormData: FormItem[] = [
  {
    name: 'code',
    value: '',
    label: 'Code',
    type: 'input',
  },
  {
    name: 'desc',
    value: '',
    label: 'Description',
    type: 'input',
  },
  {
    name: 'location',
    value: '',
    label: 'Location',
    type: 'input',
  },
  {
    name: 'type',
    value: '',
    label: 'Type',
    type: 'select',
    options: zoneTypes,
  }
];

// type: {
//   key: string;
//   value: string;
// };

// GENERIC("", "Generic"),
// DIRECTIONAL("D", "Directional"),
// SUPPLIER("F", "Supplier"),
// VARIOUS("V", "Various"),
// PROMOTIONAL("P", "Promotional"),
// AGENT("A", "Agent");
